import { render, staticRenderFns } from "./MobileColumnHeader.vue?vue&type=template&id=01a6c203&scoped=true&"
import script from "./MobileColumnHeader.vue?vue&type=script&lang=js&"
export * from "./MobileColumnHeader.vue?vue&type=script&lang=js&"
import style0 from "./MobileColumnHeader.vue?vue&type=style&index=0&id=01a6c203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a6c203",
  null
  
)

export default component.exports